import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import BaseController from '../../BaseController';
import DiagnosisService from '../diagnosis-service';
import { PanelAPI, TextAreaAPI } from '@philips-internal/oswald-ui-components';
import './diagnosis-inactivate-controller.css';
import { AbortableSubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { DiagnosisInactivationAliases, FragmentNames } from '../../../codegen';
import { ModalService } from '@philips-internal/oswald-ui-components/lib/services';
import { DialogType } from '../../../interfaces/simple-dialog';

const MAX_LENGTH_JUSTIFICATION = 500;

@Controller({ component: DiagnosisInactivationAliases.MODAL_DIAGNOSIS_INACTIVATE, fragment: FragmentNames.DIAGNOSIS_INACTIVATION })
export default class DiagnosisInactivationController extends BaseController {

  @Inject(DiagnosisInactivationAliases.JUSTIFICATION_TEXT_AREA)
    justificationTextAreaApi!: TextAreaAPI;

  @Inject(DiagnosisInactivationAliases.PANEL_LOADER)
    panelLoaderApi!: PanelAPI;

  goDiagnosisList(): void {
    ModalService.close(FragmentNames.DIAGNOSIS_INACTIVATION);
  }

  isJustificationEmptyText(): boolean {
    const justificationTextArea = this.justificationTextAreaApi.getValue().trim();
    return !justificationTextArea || justificationTextArea.length === 0;
  }

  getJustificationTextLength(): number {
    const justificationTextArea = this.justificationTextAreaApi.getValue().trim();
    return justificationTextArea ? justificationTextArea.length : 0;
  }

  @OnCancel({ target: DiagnosisInactivationAliases.JUSTIFICATION_FORM })
  onClickCancel(): void {
    this.goDiagnosisList();
  }

  @OnBeforeSubmit({ target: DiagnosisInactivationAliases.JUSTIFICATION_FORM })
  onClickInactivationJustification(event: AbortableSubmitEvent): void {
    event.abort(this.invalidateDiagnosis());
  }

  async invalidateDiagnosis(): Promise<boolean>{
    let inactivated = false;

    if (this.getJustificationTextLength() <= MAX_LENGTH_JUSTIFICATION) {
      const { sequenceNumber } = this.historyService.getCurrentRouteParams();
      const justification = this.justificationTextAreaApi.getValue();
      const sequence = sequenceNumber as number;
      const patientId = this.context.get('patientId') as number;
      const encounterId = this.context.get('encounterId') as number;
      const diagnosisService = new DiagnosisService(this);

      this.panelLoaderApi.setVisible(true);

      try {
        inactivated = await diagnosisService.inactivate(patientId, encounterId, sequence, justification);
        if (inactivated) {
          diagnosisService.showMessageDialog(
            'title.disable-record',
            'patient-evolution.successfully-inactivated-message',
            DialogType.ALERT,
            () => {},
            () => { this.goDiagnosisList() },
            '',
            'OK'
          );
        } else {
          diagnosisService.showMessageDialog(
            'patient-evolution.error-message',
            '',
            DialogType.ALERT,
            () => {},
            () => { this.goDiagnosisList() },
            '',
            'OK'
          );
        }
      } catch (error: any) {
        diagnosisService.showMessageDialog(
          'patient-evolution.error-message',
          error?.body as string,
          DialogType.ALERT,
          () => {},
          () => { this.goDiagnosisList() },
          '',
          'OK'
        );
      }
    }
    return inactivated;
  }
}
